import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=0f337830&scoped=true&"
import script from "./CreateNews.vue?vue&type=script&lang=ts&"
export * from "./CreateNews.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNews.vue?vue&type=style&index=0&id=0f337830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f337830",
  null
  
)

export default component.exports